module.exports = __webpack_public_path__ + "static/media/6-item-c.3ed07efd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/6-item-c.jpg
// module id = 1203
// module chunks = 33